import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err, info) {
    try { console.error("App crash:", err, info); } catch (e) {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px", textAlign: "center", fontFamily: "system-ui,-apple-system,Arial,sans-serif", color: "#0f172a" }} data-testid="error-boundary">
          <div style={{ fontSize: "20px", fontWeight: 700, marginBottom: "8px" }}>Si è verificato un problema</div>
          <div style={{ color: "#64748b", marginBottom: "20px", maxWidth: "420px" }}>Ricarica la pagina per continuare. Se il problema persiste, controlla la connessione o aggiorna il browser all'ultima versione.</div>
          <button onClick={() => window.location.reload()} style={{ background: "#0f766e", color: "#fff", border: "none", borderRadius: "10px", padding: "12px 22px", fontSize: "15px", fontWeight: 600 }} data-testid="error-reload-btn">Ricarica</button>
        </div>
      );
    }
    return this.props.children;
  }
}
